<template>
  <div class="contentVideo">
    <img v-show="isImgShow" class="image" :src="videoimg" @click="handlePlay" />
    <img v-show="isImgShow" class="play" src="../../assets/meb/imgs/播放@2x.png" @click="handlePlay" />
    <video
      ref="video"
      class="video"
      @pause="handlePause"
      @ended="handleEnd"
      preload
      controlslist="nodownload"
      :disablePictureInPicture="true"
    >
      <source :src="videourl" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["url", "img"],
  data() {
    return {
      isImgShow: true,
      videourl: this.url,
      videoimg: this.img
    };
  },
  mounted() {
    console.log(this);
  },
  methods: {
    handlePlay() {
      //待定的点击返回
      if (
        this.videourl == "https://www.csvw.com/u/cms/www/202010/daiding.mp4"
      ) {
        return;
      }
      // 找打所有视频，并且暂停
      let videoList = document.getElementsByTagName("video");
      var arr1 = Array.prototype.slice.call(videoList);
      arr1.forEach(item => {
        item.pause();
      });
      this.isImgShow = false;
      this.$refs.video.play();
    },
    handlePause() {
      console.log("暂停");
      this.isImgShow = true;
    },
    handleEnd() {
      console.log("结束");
      this.isImgShow = true;
      this.$refs.video.currentTime = 0;
    }
  }
};
</script>

<style lang="less" scoped>
.contentVideo {
  position: relative;
  width: 100%;
  height: 100%;
}
.image {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}
.play {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video {
  width: 100%;
}
</style>
